import { render, staticRenderFns } from "./programming.vue?vue&type=template&id=2c5b9710&scoped=true&"
import script from "./programming.vue?vue&type=script&lang=js&"
export * from "./programming.vue?vue&type=script&lang=js&"
import style0 from "./programming.vue?vue&type=style&index=0&id=2c5b9710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b9710",
  null
  
)

export default component.exports